/**
 * @generated SignedSource<<9a616fc2036ce2247f8e4131dd88f4d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppClipActionTitle = "OPEN" | "VIEW" | "%future added value";
export type AppColorPalette = "ACCENT_1" | "ACCENT_2" | "ACCENT_3" | "BACKGROUND_1" | "BACKGROUND_2" | "BLACK" | "GRAY" | "PRIMARY" | "WHITE" | "%future added value";
export type AppStoreCategory = "BOOKS" | "BUSINESS" | "DEVELOPER_TOOLS" | "EDUCATION" | "ENTERTAINMENT" | "FINANCE" | "FOOD_AND_DRINK" | "GAMES" | "GRAPHICS_AND_DESIGN" | "HEALTH_AND_FITNESS" | "LIFESTYLE" | "MAGAZINES_AND_NEWSPAPERS" | "MEDICAL" | "MUSIC" | "NAVIGATION" | "NEWS" | "PHOTO_AND_VIDEO" | "PRODUCTIVITY" | "REFERENCE" | "SHOPPING" | "SOCIAL_NETWORKING" | "SPORTS" | "STICKERS" | "TRAVEL" | "UTILITIES" | "WEATHER" | "%future added value";
export type AppTrackingConfig = "CONVERSION_BEAR" | "CUSTOM" | "ISENSE" | "ONE_TRUST" | "TERMLY" | "TRANSCEND" | "%future added value";
export type AutomatedNotificationType = "ABANDONED_BROWSE" | "ABANDONED_CART" | "ABANDONED_CHECKOUT" | "REENGAGEMENT" | "WELCOME_SERIES" | "%future added value";
export type ButtonTextStyleType = "SENTENCE_CASE" | "UPPERCASE" | "%future added value";
export type CDPAudienceType = "LIST" | "SEGMENT" | "%future added value";
export type CDPType = "EMARSYS" | "KINN" | "KLAVIYO" | "OMETRIA" | "SHOPIFY" | "%future added value";
export type IconType = "ACTIVITY" | "AIRPLAY" | "ALERT_CIRCLE" | "ALERT_OCTAGON" | "ALERT_TRIANGLE" | "ALIGN_CENTER" | "ALIGN_JUSTIFY" | "ALIGN_LEFT" | "ALIGN_RIGHT" | "ANCHOR" | "APERTURE" | "ARCHIVE" | "ARROW_DOWN" | "ARROW_DOWN_CIRCLE" | "ARROW_DOWN_LEFT" | "ARROW_DOWN_RIGHT" | "ARROW_LEFT" | "ARROW_LEFT_CIRCLE" | "ARROW_RIGHT" | "ARROW_RIGHT_CIRCLE" | "ARROW_UP" | "ARROW_UP_CIRCLE" | "ARROW_UP_LEFT" | "ARROW_UP_RIGHT" | "AT_SIGN" | "AWARD" | "BAR_CHART" | "BAR_CHART_2" | "BATTERY" | "BATTERY_CHARGING" | "BELL" | "BELL_FILL" | "BELL_OFF" | "BLUETOOTH" | "BOLD" | "BOOK" | "BOOKMARK" | "BOOK_OPEN" | "BOX" | "BRIEFCASE" | "CALENDAR" | "CAMERA" | "CAMERA_OFF" | "CAST" | "CHECK" | "CHECK_CIRCLE" | "CHECK_SQUARE" | "CHEVRONS_DOWN" | "CHEVRONS_LEFT" | "CHEVRONS_RIGHT" | "CHEVRONS_UP" | "CHEVRON_DOWN" | "CHEVRON_LEFT" | "CHEVRON_RIGHT" | "CHEVRON_UP" | "CHROME" | "CIRCLE" | "CLIPBOARD" | "CLOCK" | "CLOUD" | "CLOUD_DRIZZLE" | "CLOUD_LIGHTNING" | "CLOUD_OFF" | "CLOUD_RAIN" | "CLOUD_SNOW" | "CODE" | "CODEPEN" | "CODESANDBOX" | "COFFEE" | "COLUMNS" | "COMMAND" | "COMPASS" | "COPY" | "CORNER_DOWN_LEFT" | "CORNER_DOWN_RIGHT" | "CORNER_LEFT_DOWN" | "CORNER_LEFT_UP" | "CORNER_RIGHT_DOWN" | "CORNER_RIGHT_UP" | "CORNER_UP_LEFT" | "CORNER_UP_RIGHT" | "CPU" | "CREDIT_CARD" | "CROP" | "CROSSHAIR" | "CUSTOM_CART" | "CUSTOM_CONCIERGE" | "CUSTOM_EXPERIENCES" | "CUSTOM_FEED" | "CUSTOM_PROFILE" | "CUSTOM_SHOP" | "DATABASE" | "DELETE" | "DISC" | "DIVIDE" | "DIVIDE_CIRCLE" | "DIVIDE_SQUARE" | "DOLLAR_SIGN" | "DOWNLOAD" | "DOWNLOAD_CLOUD" | "DRIBBBLE" | "DROPLET" | "EDIT" | "EDIT_2" | "EDIT_3" | "EXTERNAL_LINK" | "EYE" | "EYE_OFF" | "FACEBOOK" | "FAST_FORWARD" | "FEATHER" | "FIGMA" | "FILE" | "FILE_MINUS" | "FILE_PLUS" | "FILE_TEXT" | "FILM" | "FILTER" | "FLAG" | "FOLDER" | "FOLDER_MINUS" | "FOLDER_PLUS" | "FOR_YOU" | "FRAMER" | "FROWN" | "GIFT" | "GITHUB" | "GITLAB" | "GIT_BRANCH" | "GIT_COMMIT" | "GIT_MERGE" | "GIT_PULL_REQUEST" | "GLOBE" | "GRID" | "HARD_DRIVE" | "HASH" | "HEADPHONES" | "HEART" | "HELP_CIRCLE" | "HEXAGON" | "HOME" | "IMAGE" | "INBOX" | "INFO" | "INSTAGRAM" | "ITALIC" | "KEY" | "LAYERS" | "LAYOUT" | "LIFE_BUOY" | "LINK" | "LINKEDIN" | "LINK_2" | "LIST" | "LOADER" | "LOCK" | "LOG_IN" | "LOG_OUT" | "MAIL" | "MAP" | "MAP_PIN" | "MAXIMIZE" | "MAXIMIZE_2" | "MEH" | "MENU" | "MESSAGE_CIRCLE" | "MESSAGE_SQUARE" | "MESSAGE_SQUARE_FILL" | "MIC" | "MIC_OFF" | "MINIMIZE" | "MINIMIZE_2" | "MINUS" | "MINUS_CIRCLE" | "MINUS_SQUARE" | "MONITOR" | "MOON" | "MORE_HORIZONTAL" | "MORE_VERTICAL" | "MOUSE_POINTER" | "MOVE" | "MUSIC" | "NAVIGATION" | "NAVIGATION_2" | "OCTAGON" | "PACKAGE" | "PAPERCLIP" | "PAUSE" | "PAUSE_CIRCLE" | "PEN_TOOL" | "PERCENT" | "PHONE" | "PHONE_CALL" | "PHONE_FORWARDED" | "PHONE_INCOMING" | "PHONE_MISSED" | "PHONE_OFF" | "PHONE_OUTGOING" | "PIE_CHART" | "PLAY" | "PLAY_CIRCLE" | "PLUS" | "PLUS_CIRCLE" | "PLUS_SQUARE" | "POCKET" | "POWER" | "PRINTER" | "RADIO" | "REFRESH_CCW" | "REFRESH_CW" | "REPEAT" | "REWIND" | "ROTATE_CCW" | "ROTATE_CW" | "RSS" | "SAVE" | "SCISSORS" | "SEARCH" | "SEND" | "SERVER" | "SETTINGS" | "SHARE" | "SHARE_2" | "SHIELD" | "SHIELD_OFF" | "SHOPPING_BAG" | "SHOPPING_CART" | "SHUFFLE" | "SIDEBAR" | "SKIP_BACK" | "SKIP_FORWARD" | "SLACK" | "SLASH" | "SLIDERS" | "SMARTPHONE" | "SMILE" | "SPEAKER" | "SQUARE" | "STAR" | "STOP_CIRCLE" | "SUN" | "SUNRISE" | "SUNSET" | "TABLE" | "TABLET" | "TAG" | "TARGET" | "TERMINAL" | "THERMOMETER" | "THUMBS_DOWN" | "THUMBS_UP" | "TOGGLE_LEFT" | "TOGGLE_RIGHT" | "TOOL" | "TRASH" | "TRASH_2" | "TRELLO" | "TRENDING_DOWN" | "TRENDING_UP" | "TRIANGLE" | "TRUCK" | "TV" | "TWITCH" | "TWITTER" | "TYPE" | "UMBRELLA" | "UNDERLINE" | "UNLOCK" | "UPLOAD" | "UPLOAD_CLOUD" | "USER" | "USERS" | "USER_CHECK" | "USER_MINUS" | "USER_PLUS" | "USER_X" | "VIDEO" | "VIDEO_OFF" | "VOICEMAIL" | "VOLUME" | "VOLUME_1" | "VOLUME_2" | "VOLUME_2_FILL" | "VOLUME_X" | "VOLUME_X_FILL" | "WATCH" | "WIFI" | "WIFI_OFF" | "WIND" | "X" | "X_CIRCLE" | "X_OCTAGON" | "X_SQUARE" | "YOUTUBE" | "ZAP" | "ZAP_OFF" | "ZOOM_IN" | "ZOOM_OUT" | "%future added value";
export type KinnLanguageCode = "AR" | "DE" | "EN" | "ES" | "FR" | "NL" | "PT" | "%future added value";
export type LaunchScreenOption = "CUSTOM" | "SIMPLE" | "%future added value";
export type TabType = "ACCOUNT" | "FORUM" | "FOR_YOU" | "NOTIFICATIONS" | "SHOP" | "WEB" | "%future added value";
export type BrandAppConfigInputPartial = {
  abandonedCartNotificationsDelaySeconds?: number | null;
  abandonedCartNotificationsEnabled?: boolean | null;
  accent1PaletteDark?: string | null;
  accent1PaletteLight?: string | null;
  accent2PaletteDark?: string | null;
  accent2PaletteLight?: string | null;
  accent3PaletteDark?: string | null;
  accent3PaletteLight?: string | null;
  androidAppLinksEnabled?: boolean | null;
  androidFirebaseAnalyticsEnabled?: boolean | null;
  appClipActionText?: AppClipActionTitle | null;
  appClipHeaderImage?: any | null;
  appClipSubtitle?: string | null;
  appContent?: BrandAppConfigContentInputPartial | null;
  appDescription?: string | null;
  appIcon?: any | null;
  appName?: string | null;
  appSubtitle?: string | null;
  automatedNotifications?: ReadonlyArray<GraphQLAutomatedNotificationInput> | null;
  background1PaletteDark?: string | null;
  background1PaletteLight?: string | null;
  background2PaletteDark?: string | null;
  background2PaletteLight?: string | null;
  buildNavigation?: BrandAppConfigBuildNavigationInputPartial | null;
  buildTheme?: BrandAppConfigBuildThemeInputPartial | null;
  cartIgnoredProductIds?: ReadonlyArray<string> | null;
  collectNameOnRegistration?: boolean | null;
  copyright?: string | null;
  enableLanguageSpecificContent?: boolean | null;
  htmlCustomAttributes?: ReadonlyArray<HTMLCustomAttributeInput> | null;
  id: string;
  iosAppClipsEnabled?: boolean | null;
  iosFirebaseAnalyticsEnabled?: boolean | null;
  iosFirebaseConfigPlist?: string | null;
  iosUniversalLinksEnabled?: boolean | null;
  keywords?: string | null;
  marketingUrl?: string | null;
  openCartAfterUpdate?: boolean | null;
  postPurchaseOptInEnabled?: boolean | null;
  primaryCategory?: AppStoreCategory | null;
  primaryPaletteDark?: string | null;
  primaryPaletteLight?: string | null;
  privacyPolicyUrl?: string | null;
  promotionalText?: string | null;
  releaseNotes?: string | null;
  screenshots?: GraphQLBrandAppConfigScreenshotInputPartialListInput | null;
  secondaryCategory?: AppStoreCategory | null;
  supportUrl?: string | null;
  supportedLanguageCodes?: ReadonlyArray<KinnLanguageCode> | null;
  trackingConfig?: BrandTrackingConfigInputPartial | null;
  usePasswordlessLogin?: boolean | null;
  wishlistUrl?: string | null;
};
export type HTMLCustomAttributeInput = {
  attributeKey: string;
  attributeValue: string;
  querySelector: string;
};
export type BrandAppConfigContentInputPartial = {
  abandonedCartNotificationBody?: string | null;
  abandonedCartNotificationTitle?: string | null;
  accountDeletionDialogSubtitle?: string | null;
  accountDeletionDialogTitle?: string | null;
  createAccountSubtitle?: string | null;
  createAccountTitle?: string | null;
  id: string;
  notificationsOptInSubtitle?: string | null;
  notificationsOptInTitle?: string | null;
  onboardingRootTitle?: string | null;
  onboardingUpsellSubtitle?: string | null;
  onboardingUpsellTitle?: string | null;
  signInSubtitle?: string | null;
  signInTitle?: string | null;
};
export type GraphQLAutomatedNotificationInput = {
  audiences?: ReadonlyArray<GraphQLCDPAudienceInput> | null;
  delaySeconds: number;
  id?: string | null;
  isEnabled?: boolean | null;
  landingPath?: string | null;
  message?: string | null;
  notifType: AutomatedNotificationType;
  resendEnabled?: boolean | null;
  title?: string | null;
};
export type GraphQLCDPAudienceInput = {
  audienceId: string;
  audienceName: string;
  audienceType: CDPAudienceType;
  cdpType: CDPType;
};
export type BrandTrackingConfigInputPartial = {
  configType: AppTrackingConfig;
  consentLocalStorageSettings?: ReadonlyArray<TrackingConfigSettingsInput> | null;
  consentSessionStorageSettings?: ReadonlyArray<TrackingConfigSettingsInput> | null;
  consentSettings: ReadonlyArray<TrackingConfigSettingsInput>;
  id?: string | null;
  nonConsentLocalStorageSettings?: ReadonlyArray<TrackingConfigSettingsInput> | null;
  nonConsentSessionStorageSettings?: ReadonlyArray<TrackingConfigSettingsInput> | null;
  nonConsentSettings: ReadonlyArray<TrackingConfigSettingsInput>;
  websiteId?: string | null;
};
export type TrackingConfigSettingsInput = {
  enabled: boolean;
  name: string;
};
export type GraphQLBrandAppConfigScreenshotInputPartialListInput = {
  add?: ReadonlyArray<GraphQLBrandAppConfigScreenshotInputPartial> | null;
  remove?: ReadonlyArray<GraphQLBrandAppConfigScreenshotInputPartial> | null;
  set?: ReadonlyArray<GraphQLBrandAppConfigScreenshotInputPartial> | null;
};
export type GraphQLBrandAppConfigScreenshotInputPartial = {
  id?: string | null;
  image?: any | null;
};
export type BrandAppConfigBuildNavigationInputPartial = {
  defaultTabType?: TabType | null;
  id: string;
  isForYouTabEnabled?: boolean | null;
  isGorgiasEnabled?: boolean | null;
};
export type BrandAppConfigBuildThemeInputPartial = {
  badgeBackground?: AppColorPalette | null;
  badgeForeground?: AppColorPalette | null;
  buttonBorderThickness?: number | null;
  buttonCartIcon?: IconType | null;
  buttonCornerRadius?: number | null;
  buttonTextStyle?: ButtonTextStyleType | null;
  fontBodyBold?: any | null;
  fontBodyRegular?: any | null;
  fontFaces?: ReadonlyArray<InternFontFamilyInfoInput> | null;
  fontHeadingBold?: any | null;
  fontHeadingRegular?: any | null;
  id: string;
  iosLiquidGlassEnabled?: boolean | null;
  launchScreenAsset?: any | null;
  launchScreenBackground?: AppColorPalette | null;
  launchScreenLogo?: any | null;
  launchScreenOption?: LaunchScreenOption | null;
  logo?: any | null;
  logoUrl?: string | null;
  navigationBackground?: AppColorPalette | null;
  navigationForeground?: AppColorPalette | null;
  notificationOptInAsset?: any | null;
  onboardingAsset?: any | null;
  onboardingBackground?: AppColorPalette | null;
  onboardingForeground?: AppColorPalette | null;
  pillContainerBackground?: AppColorPalette | null;
  primaryButtonBackground?: AppColorPalette | null;
  primaryButtonForeground?: AppColorPalette | null;
  primaryPillBackground?: AppColorPalette | null;
  primaryPillForeground?: AppColorPalette | null;
  secondaryButtonOutline?: AppColorPalette | null;
  secondaryPillOutline?: AppColorPalette | null;
  shouldUseHeaderFontForBody?: boolean | null;
};
export type InternFontFamilyInfoInput = {
  bold: InternFontWeightInfoInput;
  name: string;
  regular: InternFontWeightInfoInput;
};
export type InternFontWeightInfoInput = {
  fontFace: string;
  fontWeight: number;
  url: string;
};
export type useBrandAppConfigUpdateMutation$variables = {
  input: BrandAppConfigInputPartial;
};
export type useBrandAppConfigUpdateMutation$data = {
  readonly updateBrandAppConfig: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"AppClipTabContainer_brand" | "NavigationTab_brand" | "ScreenshotsCard_brand" | "ThemeTab_brand" | "UniversalLinkCard_brand">;
  };
};
export type useBrandAppConfigUpdateMutation = {
  response: useBrandAppConfigUpdateMutation$data;
  variables: useBrandAppConfigUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "LocalizedUrlType",
  "kind": "LinkedField",
  "name": "localizations",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "languageCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destinationUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useBrandAppConfigUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateBrandAppConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ThemeTab_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NavigationTab_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AppClipTabContainer_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UniversalLinkCard_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ScreenshotsCard_brand"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBrandAppConfigUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateBrandAppConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "collectNameOnRegistration",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "usePasswordlessLogin",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandAppConfigContentType",
                "kind": "LinkedField",
                "name": "appContent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountDeletionDialogTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountDeletionDialogSubtitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createAccountTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createAccountSubtitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "signInTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "signInSubtitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingRootTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingUpsellTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingUpsellSubtitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notificationsOptInTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notificationsOptInSubtitle",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandAppConfigBuildThemeType",
                "kind": "LinkedField",
                "name": "buildTheme",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buttonBorderThickness",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buttonCartIcon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buttonCornerRadius",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buttonTextStyle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "launchScreenOption",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "launchScreenBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "launchScreenLogoUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "launchScreenAssetUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingAssetUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notificationOptInAssetUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "logoUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BrandAppConfigBuildThemeFontType",
                    "kind": "LinkedField",
                    "name": "fonts",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shouldUseHeaderFontForBody",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iosLiquidGlassEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iosLiquidGlassRequiresNewBuild",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryButtonBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryButtonForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondaryButtonOutline",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "badgeBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "badgeForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "navigationBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "navigationForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryPillBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryPillForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondaryPillOutline",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pillContainerBackground",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accent1PaletteLight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accent2PaletteLight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accent3PaletteLight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryPaletteLight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cartIgnoredProductIds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "openCartAfterUpdate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandAppConfigBuildNavigationType",
                "kind": "LinkedField",
                "name": "buildNavigation",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isGorgiasEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isTabBarTitleEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "navTitleMode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "navTitlePosition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eligibleTabTypes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportedLanguages",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enableLanguageSpecificContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NestedMenuItemType",
                "kind": "LinkedField",
                "name": "nestedMenuItems",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NestedMenuItemType",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NestedMenuItemType",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NavigationItemType",
                "kind": "LinkedField",
                "name": "navigationItems",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v6/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NavigationItemType",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NavigationItemType",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLBrandAppTabConfig",
                "kind": "LinkedField",
                "name": "tabs",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customName",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wishlistUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosUniversalLinksEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "androidAppLinksEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosAppClipsEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandAppConfigScreenshotType",
                "kind": "LinkedField",
                "name": "screenshots",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DjangoImageType",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gorgiasId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandShopifyConfigType",
            "kind": "LinkedField",
            "name": "shopifyConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isConnected",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "domain",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a5b035927caf73293c31498a2c589a77",
    "id": null,
    "metadata": {},
    "name": "useBrandAppConfigUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation useBrandAppConfigUpdateMutation(\n  $input: BrandAppConfigInputPartial!\n) {\n  updateBrandAppConfig(input: $input) {\n    id\n    ...ThemeTab_brand\n    ...NavigationTab_brand\n    ...AppClipTabContainer_brand\n    ...UniversalLinkCard_brand\n    ...ScreenshotsCard_brand\n  }\n}\n\nfragment AccountCard_brand on BrandType {\n  appConfig {\n    id\n    collectNameOnRegistration\n    usePasswordlessLogin\n    appContent {\n      id\n      accountDeletionDialogTitle\n      accountDeletionDialogSubtitle\n      createAccountTitle\n      createAccountSubtitle\n      signInTitle\n      signInSubtitle\n    }\n  }\n}\n\nfragment AppClipTabContainer_brand on BrandType {\n  id\n  appConfig {\n    id\n    iosAppClipsEnabled\n  }\n}\n\nfragment ButtonStyleCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n      buttonBorderThickness\n      buttonCartIcon\n      buttonCornerRadius\n      buttonTextStyle\n    }\n  }\n}\n\nfragment CartCard_brand on BrandType {\n  appConfig {\n    id\n    cartIgnoredProductIds\n    openCartAfterUpdate\n  }\n}\n\nfragment ColorsCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n    }\n  }\n}\n\nfragment GorgiasCard_brand on BrandType {\n  appConfig {\n    id\n    buildNavigation {\n      id\n      isGorgiasEnabled\n    }\n  }\n  gorgiasId\n}\n\nfragment LaunchScreenCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n      launchScreenOption\n      launchScreenBackground\n      launchScreenLogoUrl\n      launchScreenAssetUrl\n    }\n  }\n}\n\nfragment LiquidGlassCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n      iosLiquidGlassEnabled\n      iosLiquidGlassRequiresNewBuild\n    }\n  }\n}\n\nfragment LogoCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n      logoUrl\n    }\n  }\n}\n\nfragment MenuCard_brand on BrandType {\n  id\n  ...useBrandLanguages_brand\n  appConfig {\n    id\n    nestedMenuItems {\n      title\n      localizations {\n        languageCode\n        text\n        url\n      }\n      destinationUrl\n      index\n      children {\n        title\n        destinationUrl\n        index\n        localizations {\n          languageCode\n          text\n          url\n        }\n        children {\n          title\n          destinationUrl\n          index\n          localizations {\n            languageCode\n            text\n            url\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NavigationTab_brand on BrandType {\n  ...CartCard_brand\n  ...GorgiasCard_brand\n  ...MenuCard_brand\n  ...ShortcutsCard_brand\n  ...TabsCard2_brand\n  ...WishlistCard_brand\n  ...UniversalLinkCard_brand\n}\n\nfragment NotificationsCard_brand on BrandType {\n  appConfig {\n    id\n    appContent {\n      id\n      notificationsOptInTitle\n      notificationsOptInSubtitle\n    }\n    buildTheme {\n      id\n      notificationOptInAssetUrl\n    }\n  }\n}\n\nfragment OnboardingCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n      onboardingAssetUrl\n      onboardingBackground\n      onboardingForeground\n    }\n    appContent {\n      id\n      onboardingRootTitle\n      onboardingUpsellTitle\n      onboardingUpsellSubtitle\n    }\n  }\n}\n\nfragment ScreenshotsCard_brand on BrandType {\n  appConfig {\n    id\n    screenshots {\n      id\n      image {\n        url\n      }\n    }\n  }\n}\n\nfragment ShortcutsCard_brand on BrandType {\n  id\n  ...useBrandLanguages_brand\n  appConfig {\n    id\n    navigationItems {\n      index\n      label\n      localizations {\n        languageCode\n        text\n        url\n      }\n      url\n      children {\n        index\n        label\n        url\n        localizations {\n          languageCode\n          text\n          url\n        }\n        children {\n          index\n          label\n          url\n          localizations {\n            languageCode\n            text\n            url\n          }\n        }\n      }\n    }\n  }\n  shopifyConfig {\n    isConnected\n    id\n  }\n}\n\nfragment TabsCard2_brand on BrandType {\n  ...useBrandLanguages_brand\n  id\n  domain\n  appConfig {\n    id\n    buildNavigation {\n      id\n      isTabBarTitleEnabled\n      navTitleMode\n      navTitlePosition\n      eligibleTabTypes\n    }\n    tabs {\n      id\n      type\n      customName\n      localizations {\n        languageCode\n        text\n        url\n      }\n      customUrl\n      icon\n    }\n  }\n}\n\nfragment ThemeTab_brand on BrandType {\n  ...AccountCard_brand\n  ...ButtonStyleCard_brand\n  ...ColorsCard_brand\n  ...LaunchScreenCard_brand\n  ...OnboardingCard_brand\n  ...NotificationsCard_brand\n  ...LogoCard_brand\n  ...TypographyCard_brand\n  ...LiquidGlassCard_brand\n  appConfig {\n    id\n    accent1PaletteLight\n    accent2PaletteLight\n    accent3PaletteLight\n    primaryPaletteLight\n    buildTheme {\n      primaryButtonBackground\n      primaryButtonForeground\n      secondaryButtonOutline\n      badgeBackground\n      badgeForeground\n      navigationBackground\n      navigationForeground\n      primaryPillBackground\n      primaryPillForeground\n      secondaryPillOutline\n      pillContainerBackground\n      id\n    }\n  }\n}\n\nfragment TypographyCard_brand on BrandType {\n  appConfig {\n    id\n    buildTheme {\n      id\n      fonts {\n        name\n        type\n        id\n      }\n      shouldUseHeaderFontForBody\n    }\n  }\n}\n\nfragment UniversalLinkCard_brand on BrandType {\n  appConfig {\n    id\n    iosUniversalLinksEnabled\n    androidAppLinksEnabled\n  }\n}\n\nfragment WishlistCard_brand on BrandType {\n  appConfig {\n    id\n    wishlistUrl\n  }\n}\n\nfragment useBrandLanguages_brand on BrandType {\n  appConfig {\n    supportedLanguages\n    enableLanguageSpecificContent\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "51db822b127dc04d917f32830ba8d58d";

export default node;
